import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { loadExtensions } from '@/checkout-instore-legacy/extensions/utils'
import { getVendor } from '@/checkout-instore-legacy/utils/vendorUtils'
import {
  getAccountName,
  getWorkspace,
} from '@/checkout-instore-legacy/utils/UrlUtils'
import { getIntlLocale } from '@/checkout-instore-legacy/i18n/utils'
import Spinner from '@vtex/styleguide/lib/Spinner'

const dashboardWrapperDivId = 'dashboard-wrapper-div'
export default class DashboardWrapper extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoadingExtension: true,
    }

    this.loadExtension()
  }

  loadExtension = () => {
    if (!window.RenderExtensionLoader) {
      console.log(
        'Could not load extension: window RenderExtensionLoader is',
        window.RenderExtensionLoader
      )
      return
    }

    loadExtensions('/instore-dashboard').then((loader) => {
      if (!loader) {
        return
      }

      loader.render(
        'instore-dashboard',
        document.getElementById(dashboardWrapperDivId),
        {
          vendor: getVendor(),
          locale: getIntlLocale(),
          an: getAccountName(),
          workspace: getWorkspace(),
        }
      )
      this.setState({
        isLoadingExtension: false,
      })
    })
  }

  render() {
    const { isLoadingExtension } = this.state
    return (
      <Fragment>
        {isLoadingExtension ? (
          <div className="h-100 w-100 bg-muted-5 flex flex-column items-center justify-center">
            <Spinner />
          </div>
        ) : null}
        <div
          className={isLoadingExtension ? '' : 'h-100'}
          id={dashboardWrapperDivId}
        />
      </Fragment>
    )
  }
}

DashboardWrapper.propTypes = {
  router: PropTypes.any,
  nativeAppInfo: PropTypes.object,
}
